import { render, staticRenderFns } from "./OneConsultDetails.vue?vue&type=template&id=039c4c58&scoped=true"
import script from "./OneConsultDetails.vue?vue&type=script&lang=js"
export * from "./OneConsultDetails.vue?vue&type=script&lang=js"
import style0 from "./OneConsultDetails.vue?vue&type=style&index=0&id=039c4c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039c4c58",
  null
  
)

export default component.exports